export default {"src":"/_next/static/image/public/images/flags/flag_593.6166f5e18aa42b48ef941bfd4596903e.svg","height":16,"width":25};